function helperStringUpperCase (str) {
  return str.toUpperCase()
}

module.exports = helperStringUpperCase



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/helperStringUpperCase.js
// module id = 511
// module chunks = 75